const MS_PER_MINUTE = 60 * 1000;

/**
 * Re-anchors an instant so that reading it with the LOCAL getters yields its UTC wall clock, which
 * is what a picker bound to a UTC-based field needs.
 *
 * Replaces `date-fns-tz`'s `toZonedTime(date, 'UTC')`, the only thing that package was used for.
 *
 * The shift is the offset of the RESULT, not of the input. Shifting by the input's offset alone
 * lands an hour off whenever the two straddle a DST transition; the first shift only has to get
 * close enough to read the right offset, which the second one then applies.
 *
 * The result is a DIFFERENT instant: only its local calendar fields are meaningful, so never send
 * it to an API or compare it against a real timestamp.
 */
export const toUtcWallClock = (date: Date) => {
  const approximate = new Date(date.getTime() + date.getTimezoneOffset() * MS_PER_MINUTE);
  return new Date(date.getTime() + approximate.getTimezoneOffset() * MS_PER_MINUTE);
};
